/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Client,
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
    MonitoredObject,
    MonitoredObjectFromJSON,
    MonitoredObjectFromJSONTyped,
    MonitoredObjectToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyOBUNested
 */
export interface ReadOnlyOBUNested {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyOBUNested
     */
    id?: string;
    /**
     * 
     * @type {Client}
     * @memberof ReadOnlyOBUNested
     */
    client?: Client;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyOBUNested
     */
    type: string;
    /**
     * 
     * @type {MonitoredObject}
     * @memberof ReadOnlyOBUNested
     */
    monitoredObject?: MonitoredObject;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyOBUNested
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyOBUNested
     */
    identificationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyOBUNested
     */
    serialNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyOBUNested
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyOBUNested
     */
    activatedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyOBUNested
     */
    vehicleBrand: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyOBUNested
     */
    imei: string;
}

export function ReadOnlyOBUNestedFromJSON(json: any): ReadOnlyOBUNested {
    return ReadOnlyOBUNestedFromJSONTyped(json, false);
}

export function ReadOnlyOBUNestedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyOBUNested {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'client': !exists(json, 'client') ? undefined : ClientFromJSON(json['client']),
        'type': json['type'],
        'monitoredObject': !exists(json, 'monitored_object') ? undefined : MonitoredObjectFromJSON(json['monitored_object']),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'identificationNumber': json['identification_number'],
        'serialNumber': json['serial_number'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'activatedAt': !exists(json, 'activated_at') ? undefined : (json['activated_at'] === null ? null : new Date(json['activated_at'])),
        'vehicleBrand': json['vehicle_brand'],
        'imei': json['imei'],
    };
}

export function ReadOnlyOBUNestedToJSON(value?: ReadOnlyOBUNested | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'client': ClientToJSON(value.client),
        'type': value.type,
        'monitored_object': MonitoredObjectToJSON(value.monitoredObject),
        'identification_number': value.identificationNumber,
        'serial_number': value.serialNumber,
        'activated_at': value.activatedAt === undefined ? undefined : (value.activatedAt === null ? null : value.activatedAt.toISOString()),
        'vehicle_brand': value.vehicleBrand,
        'imei': value.imei,
    };
}


